<template>
    <div class="batch-upload">
        <transition name="fade"> 
            <alart-msg :display="fail.status" styleType="error" @alartStatus="closeAlart">
                <span class="title" slot="title">{{fail.msg}}</span>
            </alart-msg>
        </transition>  
        <Breadcrumb />
        <batch-house :class="{'fixed': listIsFixed}"></batch-house>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import BatchHouse from '@/components/landlord/houseStatus/houseManagement/batchHouse/BatchHouse.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            alart: this.isFail,
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        closeAlart: function () {
            this.$store.commit('batchUpload/set_fail', {status: false, msg: ''})
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('batch-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('batch-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            fail: 'GET_BATCH_FAIL'
        })
    },
    components: {
        Breadcrumb,
        AlartMsg,
        BatchHouse
    }
}
</script>
<style lang="scss" scoped>
    .batch-upload{
        position: relative;
        margin-top: 82px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/BatchUpload.vue